import React, { FC } from 'react';

import Typography from '@mui/material/Typography';
import Theme from '@src/theme';

import scaleIcon from '@assets/vault/liquidityPositions/scale.svg?url';
import documentsIcon from '@assets/vaults/menu/documents.svg?url';

import Link from '@components/common/Link';
import Tooltip from '@components/common/Tooltip';

import { Size } from '@constants/common/ui.constants';
import { AILM_DOCS } from '@constants/vaults/common.constants';
import {
  REBALANCE_STATUS_TITLE,
  RebalanceStatus,
} from '@constants/vaults/vault.constants';

import useStyles from './styles.module';

const STATUSES = [
  {
    color: Theme.secondary.s3,
    title: REBALANCE_STATUS_TITLE[RebalanceStatus.Fixed],
    desc: 'AiLM activated. Rebalancing can NOT be paused',
  },
  {
    color: Theme.accent.a1,
    title: REBALANCE_STATUS_TITLE[RebalanceStatus.Active],
    desc: 'Manual range selected. Rebalancing is ON',
  },
  {
    color: Theme.accent.a4,
    title: REBALANCE_STATUS_TITLE[RebalanceStatus.Paused],
    desc: 'Manual range selected. Rebalancing is OFF',
  },
];

const AutomaticRebalancingTooltip: FC = () => {
  const { classes } = useStyles();

  return (
    <Tooltip>
      <div className={classes.inner}>
        <img src={scaleIcon} alt="" className={classes.icon} />
        <div className={classes.content}>
          <Typography variant="h4">Automatic Rebalancing</Typography>
          <Typography variant="body2">
            3 ways to rebalance your liquidity
          </Typography>

          <div className={classes.list}>
            {STATUSES.map((item) => (
              <Typography key={item.title} variant="caption1">
                <span style={{ color: item.color }}>{item.title}</span>
                {item.desc}
              </Typography>
            ))}
          </div>

          <div className={classes.learnMore}>
            <img src={documentsIcon} alt="" className={classes.docsIcon} />
            <Typography variant="caption1">Learn more in our</Typography>
            <Link
              title="Documentation"
              href={AILM_DOCS}
              newTab
              isUnderline={false}
              size={Size.Small}
            />
          </div>
        </div>
      </div>
    </Tooltip>
  );
};

export default AutomaticRebalancingTooltip;
